<ideal-wire-cut-custom-length-selector-view [lengths]="customLengths()" [itemId]="itemId()" (lengthsChange)="onLengthsChange($event)" />
